/**
 * ============================================================================
 * EL-ARO
 * COMPONENT: Navigation
 * FILE: assets/elaro-navigation.js
 * ============================================================================
 */

class ElaroNavigation {

    constructor(root) {

        this.root = root;

        this.links = [

            ...root.querySelectorAll("[data-navigation-link]")

        ];

        this.bindEvents();

    }

    /*==========================================================================
      Events
    ==========================================================================*/

    bindEvents() {

        this.links.forEach(link => {

            link.addEventListener(

                "mouseenter",

                () => {

                    this.open(link);

                }

            );

            link.addEventListener(

                "focus",

                () => {

                    this.open(link);

                }

            );

        });

    }

    /*==========================================================================
      Open / Close
    ==========================================================================*/

    open(link) {

        this.links.forEach(item => {

            item.setAttribute(

                "aria-expanded",

                "false"

            );

            item.parentElement.classList.remove(

                "is-active"

            );

        });

        const menuId = link.dataset.megaTrigger;

        /*
        ------------------------------------------------------------------------
        No mega menu
        ------------------------------------------------------------------------
        */

        if (!menuId) {

            document.dispatchEvent(

                new CustomEvent(

                    "navigation:clear"

                )

            );

            return;

        }

        /*
        ------------------------------------------------------------------------
        Mega menu
        ------------------------------------------------------------------------
        */

        link.setAttribute(

            "aria-expanded",

            "true"

        );

        link.parentElement.classList.add(

            "is-active"

        );

        document.dispatchEvent(

            new CustomEvent(

                "navigation:open",

                {

                    detail: {

                        menuId

                    }

                }

            )

        );

    }

}

/*==============================================================================
  Initialize
==============================================================================*/

document.addEventListener(

    "DOMContentLoaded",

    () => {

        document

            .querySelectorAll("[data-navigation]")

            .forEach(nav => {

                new ElaroNavigation(nav);

            });

    }

);